import { Instance } from 'mobx-state-tree';
import { ImportShopifyOrdersResultDtoModelBase } from './ImportShopifyOrdersResultDtoModel.base';

/* The TypeScript type of an instance of ImportShopifyOrdersResultDtoModel */
export interface ImportShopifyOrdersResultDtoModelType extends Instance<typeof ImportShopifyOrdersResultDtoModel.Type> {}

/* A graphql query fragment builders for ImportShopifyOrdersResultDtoModel */
export { selectFromImportShopifyOrdersResultDto, importShopifyOrdersResultDtoModelPrimitives, ImportShopifyOrdersResultDtoModelSelector } from './ImportShopifyOrdersResultDtoModel.base';

/**
 * ImportShopifyOrdersResultDtoModel
 */
export const ImportShopifyOrdersResultDtoModel = ImportShopifyOrdersResultDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
